import { lazy } from "react"
import { Route } from "react-router-dom"

const DirectReports = lazy(() => import("./direct-reports/DirectReports"))
const WhatsNew = lazy(() => import("../whats-new"))

const ProfileWrapper = lazy(() => import("./profile/Profile"))
const PayAndJob = lazy(() => import("./profile/job-and-pay/JobAndPay"))
const Personal = lazy(() => import("./profile/personal/Personal"))
const Requests = lazy(() => import("./profile/requests/Requests"))
const Documents = lazy(() => import("./profile/documents/Documents"))
const Assets = lazy(() => import("./profile/assets/Assets"))
const Tasks = lazy(() => import("./profile/tasks/Task"))
const Disciplinary = lazy(() => import("./profile/disciplinary/Disciplinary"))
const LeaveBalances = lazy(() => import("./profile/requests/LeaveBalances"))
const Overview = lazy(() => import("./performance/overview/Overview"))
const ManagerOKR = lazy(() => import("./performance/okr/Okr"))
const ManagerViewIndividual = lazy(
  () => import("./performance/okr/individual/ViewIndividual")
)
const HodOKR = lazy(() => import("./performance/HOD/okr/Okr"))
const ViewSingleTeam = lazy(
  () => import("./performance/HOD/okr/team/ViewSingleTeam")
)
const HodOverview = lazy(() => import("./performance/HOD/Overview"))
const PendingApproval = lazy(() => import("./performance/okr/PendingApproval"))

// #region OKR
// const Okr = lazy(() => import("./performance/okr/"))

// #region Review Period
const ReviewPeriod = lazy(
  () => import("./performance/reviews/review-period/ReviewPeriod")
)
const ViewReviewPeriod = lazy(
  () => import("./performance/reviews/review-period/ViewReviewPeriod")
)
const PeerNominations = lazy(
  () =>
    import("./performance/reviews/review-period/nominations/PeerNominations")
)
const StartEmployeeReview = lazy(
  () => import("./performance/reviews/review-period/start-review/StartReview")
)
const ViewReviewPeriodEmployee = lazy(
  () =>
    import(
      "./performance/reviews/review-period/view-review/ViewReviewPeriodEmployee"
    )
)
const ViewEmployeeReviewers = lazy(
  () => import("./performance/reviews/review-period/ViewRevieweeReviewers")
)

// #endregion Review Period

export const managerRoutes = (
  <>
    <Route
      path="direct-reports"
      element={<DirectReports />}
    />
    <Route
      path="whats-new"
      element={<WhatsNew />}
    />
    <Route
      path="direct-reports/:employeeKey"
      element={<ProfileWrapper />}
    >
      <Route
        path="job-and-pay"
        element={<PayAndJob />}
      />
      <Route
        path="personal"
        element={<Personal />}
      />
      <Route
        path="requests"
        element={<Requests />}
      />

      <Route
        path="documents"
        element={<Documents />}
      />
      <Route
        path="assets"
        element={<Assets />}
      />
      <Route
        path="tasks"
        element={<Tasks />}
      />
      <Route
        path="disciplinary"
        element={<Disciplinary />}
      />
    </Route>
    <Route
      path="direct-reports/:employeeKey/leave-balances"
      element={<LeaveBalances />}
    />
    {/*
    // #region PERFORMANCE
     */}
    {/* MANAGER - Overview */}
    <Route
      path="performance/overview"
      element={<Overview />}
    />
    {/* MANAGER - OKR */}
    <Route
      path="performance/okr"
      element={<ManagerOKR />}
    />
    <Route
      path="performance/okr/individual"
      element={<ManagerViewIndividual />}
    />
    <Route
      path="performance/okr/review"
      element={<PendingApproval />}
    />
    {/* HOD - Overview */}
    <Route
      path="performance/hod/overview"
      element={<HodOverview />}
    />
    {/* HOD - OKR */}
    <Route
      path="performance/hod/okr"
      element={<HodOKR />}
    />
    <Route
      path="performance/hod/okr/individual"
      element={<ManagerViewIndividual />}
    />
    <Route
      path="performance/hod/team"
      element={<ViewSingleTeam />}
    />
    {/* MANAGER - Review Period */}
    <Route
      path="performance/review/review-period"
      element={<ReviewPeriod />}
    />
    <Route
      path="performance/review/review-period/:reviewPeriodKey"
      element={<ViewReviewPeriod />}
    />
    <Route
      path="performance/review/review-period/:reviewPeriodKey/nominations"
      element={<PeerNominations />}
    />
    <Route
      path="performance/review/start/:assignmentKey"
      element={<StartEmployeeReview />}
    />
    {/* HOD - Review Period */}
    <Route
      path="performance/hod/review/review-period"
      element={<ReviewPeriod />}
    />
    <Route
      path="performance/hod/review/review-period/:reviewPeriodKey"
      element={<ViewReviewPeriod />}
    />
    {/* <Route
      path="performance/hod/review/start/:assignmentKey"
      element={<StartEmployeeReview />}
    /> */}
    <Route
      path="performance/hod/review/view/:reviewPeriodKey/reviewees/:revieweeKey"
      element={<ViewEmployeeReviewers />}
    />
    <Route
      path="performance/hod/review/view/:cdKey/:reviewPeriodKey/:revieweeKey"
      element={<ViewReviewPeriodEmployee />}
    />
    {/*
    // #endregion PERFORMANCE
     */}
  </>
)
